<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <div class="mod-custom">
          <div class="clse">
            <v-btn icon @click.stop="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-container>
              <v-row class="custom">
                <v-col md="12">
                  <div class="md-tl">
                    <p>Nuevo archivo</p>
                    <!-- <p>_id: {{ this.form._id }}</p> -->
                    <!-- <p>parent: {{ this.parent }}</p> -->
                    <!-- <p>
                      parent: {{ this.parent._id }} - {{ this.parent.name }}
                    </p> -->
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    ref="file_features"
                    name="file_features"
                    v-model="form.file_features"
                    accept=".csv, .png, .jpg, .jpeg, .doc, .docx, .pdf, .xls, .xlsx"
                    @change="onFileChange"
                    :rules="fieldRules"
                    label="Subir Archivo"
                  ></v-file-input>

                  <!-- <v-text-field
                    ref="name"
                    name="name"
                    outlined
                    v-model="form.name"
                    :rules="nameRules"
                    label="Nombre de la carpeta"
                    required
                  ></v-text-field> -->
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    outlined
                    ref="description"
                    name="description"
                    v-model="form.description"
                    label="Descripción"
                    placeholder="Describe brevemente este archivo, permitira encontrarlo de manera mas rapida."
                  ></v-textarea>
                  <p>
                    <!-- {{ this.form }} -->
                  </p>
                </v-col>
              </v-row>
            </v-container>

            <v-spacer></v-spacer>
            <v-progress-linear
              v-if="loading == true"
              color="orange darken-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
            <div class="ctn_btn_shop">
              <v-btn
                :disabled="!valid"
                depressed
                large
                color="primary"
                @click="validate"
                >Subir Archivo</v-btn
              >
            </div>
          </v-form>
        </div>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FileNew",
  components: {},
  props: ["visible", "space", "parent"],
  data() {
    return {
      form: {
        name: null,
        file_features: null,
        description: null,
        parent: null,
        space: null
      },
      loading: false,
      arrayCompany: null,
      valid: true,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
      search: "",
      itemsCompany: []
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
      }
    });
  },
  updated() {},
  watch: {},
  methods: {
    ...mapActions(["addFile"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.valid = false;
        this.loading = true;
        setTimeout(() => {
          this.register();
        }, 3000);
        //console.log("register");
      }
    },
    onFileChange(e) {
      if (this.form.file_features != null) {
        const file = e;
        //console.log("obj", e);
        //console.log("obj", file);
        this.form.name = file.name;
      } else {
        this.form.name = null;
      }
    },

    async register() {
      try {
        //this.form.ancestors = this.space.ancestors
        this.form.space = this.parent._id;
        this.form.user = this.parent.user;
        this.form.parent = this.parent._id;
        const formData = new FormData();

        formData.append("name", this.form.name);
        formData.append("description", this.form.description);
        formData.append("user", this.form.user);
        formData.append("space", this.form.parent);
        formData.append("parent", this.form.parent);
        formData.append("file_features", this.form.file_features);

        //console.log("Subir archivo", formData);
        let responsed = await this.addFile(formData);

        if (responsed == 200) {
          this.$refs.form.reset();
          // load
          this.loading = false;
          this.valid = true;
          //console.log("creado", responsed);
          this.$root.$emit("reload");
          this.$root.$emit("snackbar", {
            status: 200,
            visible: true,
            text: `El archivo se ha creado.`
          });
          this.show = false; // parametro update tabla
        }
      } catch (error) {
        this.$refs.form.reset();
        // load
        this.loading = false;
        this.valid = true;
        //console.log("error catch", error);
        this.$root.$emit("snackbar", {
          status: 404,
          visible: true,
          text: `Ocurrió un error inesperado - ${error}`
        });
        this.show = false;
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      }
    }
  }
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
